import React from "react"

const ValueImageCard = ({ image, alt = "", wide = false, className }) => {
  return (
    <figure
      className={`value-image${wide ? " is-wide" : ""} ${className ?? ""}`}
    >
      <img src={image} alt={alt} loading="lazy" decoding="async" />
    </figure>
  )
}

export default ValueImageCard
